import { CLEAR_PARTIAL_FORM_KEYS } from 'root/src/client/logic/form/actionIds'
import { formStoreLenses } from 'root/src/client/logic/form/lenses'

const { setFormChild } = formStoreLenses

export const clearPartialFormKeys = (state, { moduleKey }) => setFormChild(`db-${moduleKey}`, {})(state)
export default {
	[CLEAR_PARTIAL_FORM_KEYS]: clearPartialFormKeys,
}
